import { render, staticRenderFns } from "./PostPlantPerformance.vue?vue&type=template&id=4ba0217c&scoped=true&"
import script from "./PostPlantPerformance.vue?vue&type=script&lang=js&"
export * from "./PostPlantPerformance.vue?vue&type=script&lang=js&"
import style0 from "./PostPlantPerformance.vue?vue&type=style&index=0&id=4ba0217c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0217c",
  null
  
)

export default component.exports